module.exports = __webpack_public_path__ + "static/von-der-frage-bis-zur-loesung-img-320c5f1a2cfbf71b35f2bd999c618fdf.jpg";